export const menuItems = ['Home', 'About Us', 'Products', 'Our Values', 'Contact Us', 'Our Projects']
export const MAPS_LINK = 'https://maps.app.goo.gl/xMqQMTgJvtkT6gEJ6';
export const WHATSAPP_LINK = 'https://wa.link/dk81e1';
export const COMPANY_MOBILE_NO = '+6285213058900';
export const COMPANY_MOBILE_NO_2 = '+62811177336';
export const COMPANY_EMAIL = 'sales@hatiga.co.id';
export const CAROUSEL_RESPONSIVE_SIZES_LOGO = {
  desktop: {
    breakpoint: { max: 3000, min: 1000 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1000, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  }
};
export const CAROUSEL_RESPONSIVE_SIZES_CHARITY = {
  desktop: {
    breakpoint: { max: 3000, min: 1000 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1000, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  }
};